import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAxios } from "../../hooks/useAxios";

export interface IAddUsersToWorkspaceParams {
  emails: Array<string>;
  sendEmailNotifications: boolean;
}

export enum ErrorType {
  None = "NONE",
  AlreadyInWorkspace = "ALREADY_IN_WORKSPACE",
  HasExistingWorkspace = "HAS_EXISTING_WORKSPACE",
  InvalidEmail = "INVALID_EMAIL",
  IsStudent = "IS_STUDENT",
  Internal = "INTERNAL",
}

export interface IAddUsersToWorkspaceResponse {
  results: Array<{
    email_address: string;
    error_type: ErrorType;
  }>;
}

export default function useAddUsersToWorkspace(): UseMutationResult<
  IAddUsersToWorkspaceResponse,
  unknown,
  IAddUsersToWorkspaceParams
> {
  const axios = useAxios();
  const queryClient = useQueryClient();

  const AddUsersToWorkspace = async (args: IAddUsersToWorkspaceParams) => {
    const { emails, sendEmailNotifications } = args;

    const response = await axios({
      method: "post",
      url: `/v1/workspaces/users`,
      data: {
        email_addresses: emails,
        send_email_notifications: sendEmailNotifications,
      },
    }).then((r) => r.data as IAddUsersToWorkspaceResponse);

    queryClient.invalidateQueries(["workspaceUsers"]);
    queryClient.invalidateQueries([
      "top-workspace-session-creators",
      { exact: false },
    ]);
    queryClient.invalidateQueries([
      "top-workspace-assignment-creators",
      { exact: false },
    ]);
    queryClient.invalidateQueries([
      "educator-with-group-details-bulk",
      { exact: false },
    ]);

    return response;
  };

  const mutation = useMutation(AddUsersToWorkspace);

  return mutation;
}
